import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { storeToRefs } from 'pinia'
import { nextTick } from 'vue'
import { useMessageStack } from '@provise/stores/messagestack'
import { useUiStore } from '@provise/stores/ui'
import { useUserStore } from '@provise/stores/user'
import dropdown from '@provise/directives/dropdown'
import { ApiError } from '@provise/composables/api'

/**
 *
 * @param {import { App } from "vue";} app
 */
export function initApp(app) {
  const messageStack = useMessageStack()
  const { user } = storeToRefs(useUserStore())
  const { blockScreen } = storeToRefs(useUiStore())

  library.add(far)
  library.add(fas)
  app.component('x-icon', FontAwesomeIcon)

  app.directive('dropdown', dropdown)

  app.config.errorHandler = errorHandler
  window.onerror = (m, u, l, c, e) => errorHandler(e)
  window.onunhandledrejection = ({ reason }) => errorHandler(reason.message)

  async function errorHandler(err) {
    console.error(err)
    let errMessage = String(err)

    if (err instanceof ApiError) {
      if (err.code === 401) {
        user.value = undefined
        errMessage = 'Сессия устарела'
      } else {
        errMessage = `Проверьте подключение к серверу: ${err.status} ${err.message}`
      }
    }
    blockScreen.value = false
    messageStack.push({ type: 'error', message: errMessage })
  }

  const { $router, defaultTitle } = app.config.globalProperties
  $router.afterEach(async to => {
    await nextTick()
    let t = []
    for (let m of to.matched) {
      t = [...t, m.meta.title]
    }
    t.reverse()
    t = [...t, defaultTitle]
    document.title = to.meta.title ? t.join(' / ') : defaultTitle
  })
}
